<template>
  <div>
    <template v-if="isLink">
      <a :class="linkClass" :target="target" :href="$sanitizeUrl(item.href)">
        <template v-if="hasIcon">
          <ion-icon class="icon" :name="item.icon" />
        </template>
        <MEBadge position="center" variant="danger" :show-badge="!!item.badge.visible" :content="item.badge.content">
          <span>{{ item.label }}</span>
        </MEBadge>
      </a>
    </template>
    <template v-else-if="isSubitemLink">
      <a :class="linkClass" @click="callback(item.key, $event)">
        <ion-icon class="icon" v-if="(hasIcon)" :name="item.icon" />
        <span>{{ item.label }}</span>
        <span class="sidebar__nav-chevron" :class="{'sidebar__nav-chevron--open' : open}">
          <ion-icon class="vector" name="chevron-down-sharp"></ion-icon>
        </span>
      </a>
    </template>
  </div>
</template>

<script>
import MEBadge from "commons/js/components/ME/MEBadge/MEBadge";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    callback: {
      type: Function,
      default: undefined,
    },
    open: {
      type: Boolean,
      default: false,
    },
    subitem: {
      type: Boolean,
      default: false,
    },
    page: {
      type: String,
      default: undefined,
    }
  },

  components: {
    MEBadge,
  },

  computed: {
    isLink() {
      return ('href' in this.item) && !!this.item.href;
    },

    isSubitemLink() {
      return 'subitems' in this.item;
    },

    hasIcon() {
      return 'icon' in this.item;
    },

    linkClass() {
      return {
        'sidebar__nav-subitemlink': this.subitem,
        'sidebar__nav-link': !this.subitem,
        'active': ('key' in this.item && this.item.key === this.page),
      }
    },

    target() {
      return 'external' in this.item ? '_blank' : '_self';
    },

    isVisible() {
      if ('visible' in this.item) {
        return this.item.visible();
      }

      return true;
    }
  }
};
</script>
